import { customElement } from "lit/decorators.js";
import { inject } from "ui-common/di";
import { CommunityFormPage } from "./community-form-page";
import type { ICreatorCommunitiesService } from "../../services/creator-communities/types";
import { translate } from "../../translations/i18n";

@customElement("create-community-page")
export class CreateCommunityPage extends CommunityFormPage {
  @inject<ICreatorCommunitiesService>("creatorCommunitiesService")
  private communitiesCleanupService!: ICreatorCommunitiesService;

  private autoCreatedDraft = false;

  get mode() {
    return "create" as const;
  }

  get pageTitle() {
    return translate("communitiesPage.createPageTitle");
  }

  override connectedCallback(): void {
    super.connectedCallback();
    this.formService.reset();
    this.formService.loadAvailableEvents();
  }

  protected override async onAutoSaveDraft(): Promise<void> {
    if (!this.autoCreatedDraft) {
      this.autoCreatedDraft = true;
    }
  }

  override async canDeactivate(): Promise<boolean> {
    if (this.isSaved) return true;
    if (this.autoCreatedDraft && !this.isSaved) {
      const communityId = this.formState.communityId.get();
      if (communityId) {
        try {
          await this.communitiesCleanupService.deleteCommunity(communityId);
        } catch {
          // Cleanup failed silently — community remains as draft
        }
      }
      return true;
    }
    return super.canDeactivate();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "create-community-page": CreateCommunityPage;
  }
}
